import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AbTronco } from 'app/abstract/full-pages/voip/tronco.abstract';
import { AppFilter } from 'app/models/app-filter.model';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class TroncoService extends AbTronco {

  prefixo = "troncos";

  constructor(http: HttpClient) {
    super(http);
  }

  public salvar(tronco: any): Observable<any> {
    return this.save(`${this.prefixo}/`, tronco);
  }

  public getAllTroncos(filter: AppFilter): Observable<any> {
    return this.get(`${this.prefixo}/ativos/${filter.encode()}`);
  }

  public getAllTroncosDTO(): Observable<any> {
    return this.get(`${this.prefixo}/ativos`);
  }

  public desativar(id: number) {
    return this.delete(`${this.prefixo}/desativar/`, id);
  }

  public getConfigSIP(): any {
    return this.get(`${this.prefixo}/configSIP/`);
  }
}
